import { CampaignItem } from '../../PruleadInsightsReporting/types/insights-types';

export type KeyTaskLinkParams = Record<string, unknown> & {
  linkParams?: Record<string, string | undefined>;
};

export enum ValidStatusEnum {
  ALL = 'all',
  VALID = 'valid',
  INVALID = 'invalid',
}

export enum CategoryEnum {
  CUSTOMER_OFFER = 'CustomerOffer',
  TIMETABLE = 'Timetable',
  MANAGEMENT_MESSAGE = 'ManagementMessage',
}

export enum DisplayFormatEnum {
  DISPLAY_DATE = 'displayDate',
  COUNTDOWN_DAYS = 'countdownDays',
}

export enum PublishedStatusEnum {
  ALL = 'all',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
}

export enum RedirectTypeEnum {
  NO = 'no',
  APP = 'app',
  EXTERNAL = 'external',
}

export enum OpenByTypeEnum {
  WEBVIEW = 'webview',
  BROWSER = 'browser',
}

export enum FormModeEnum {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export interface CampaignOption {
  id: string;
  name: string;
  status: string;
}

// Form model; API records store selectedCampaign as an ID.
export interface KeyTaskConfiguration {
  id?: string;
  category: CategoryEnum;
  contentEn: string;
  contentZhHk: string;
  order: number | undefined;
  effectiveStartDate: Date | null;
  effectiveEndDate: Date | null;
  publishedStatus: Exclude<PublishedStatusEnum, PublishedStatusEnum.ALL> | '';

  // Selected campaign reference for Customer Offer Category
  selectedCampaign?: Pick<CampaignItem, '_id'> | null;

  // Countdown date and display format for Timetable Category
  countdownDate?: Date | null;
  displayFormat?: DisplayFormatEnum | '';

  // Redirect and link related fields for Management Messages Category
  redirectTo?: RedirectTypeEnum | '';
  link?: string;
  params?: KeyTaskLinkParams | null;
  openBy?: OpenByTypeEnum | '';
  canShare?: boolean | '';
}

export interface KeyTaskRecord extends Omit<KeyTaskConfiguration, 'selectedCampaign'> {
  id: string;
  selectedCampaign?: string | null;
}

export interface KeyTaskConfigurationForSave extends KeyTaskConfiguration {
  selectedCampaignId?: string;
}

export interface KeyTaskListParam {
  name?: string;
  publishedStatus: PublishedStatusEnum;
  publishedStartDate?: Date | null;
  publishedEndDate?: Date | null;
  category: CategoryEnum | 'all';

  validStatus: ValidStatusEnum;
  page: number;
  limit: number;
  pagination: boolean;
}

export type ConfigurationErrors = Partial<Record<keyof KeyTaskConfiguration, string>>;
